import React from 'react';
import { Dialog, DialogContent, Grid, Typography } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import StyledDialog from '../../../../../common/models/Dialog';
import StyledButton from '../../../../../common/models/Button';

// Result popup for Save filters / Clear All Filters.
// Deliberately identical to the Purchase Order dashboard's filter dialogs
// (PurchaseOrderDashbaordIndex/PurchaseOrderDashboard.jsx:5383-5463): the
// success case is the shared StyledDialog (green tick + title), and the
// failure case is the same red-bordered "Something went wrong. Please try
// again." panel with a Close link and an Ok button.
const FilterDialogSection = ({ filterDialog, handleCloseFilterDialog }) => {
  const isOpen = Boolean(filterDialog?.open);
  const isSuccess = filterDialog?.success !== false;

  return (
    <React.Fragment>
      <Dialog open={isOpen && isSuccess} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseFilterDialog}
          title={filterDialog?.title}
        />
      </Dialog>
      <Dialog
        open={isOpen && !isSuccess}
        onClose={handleCloseFilterDialog}
        fullWidth
      >
        <DialogContent style={{ padding: '2rem' }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: '1rem',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={handleCloseFilterDialog}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <WarningIcon
                style={{
                  fontSize: '5rem',
                  color: '#F00',
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '80px',
              border: '2px solid #FF0000',
              backgroundColor: '#FFF0F0',
            }}
          >
            <Typography style={{ textAlign: 'center' }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              padding: '0.5rem',
            }}
          >
            <StyledButton
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
              onClick={handleCloseFilterDialog}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default FilterDialogSection;
